import { render, staticRenderFns } from "./local-doku.vue?vue&type=template&id=700552d2"
import script from "./local-doku.vue?vue&type=script&lang=js"
export * from "./local-doku.vue?vue&type=script&lang=js"
import style0 from "./local-doku.vue?vue&type=style&index=0&id=700552d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports